var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 0C3.00301 0 1.37836 1.62465 1.37836 3.6216C1.37836 6.09988 4.61935 9.73814 4.75734 9.89182C4.88695 10.0362 5.11324 10.0359 5.24261 9.89182C5.3806 9.73814 8.6216 6.09988 8.6216 3.6216C8.62156 1.62465 6.99693 0 4.99998 0ZM4.99998 5.44373C3.99525 5.44373 3.17787 4.62633 3.17787 3.6216C3.17787 2.61687 3.99527 1.79949 4.99998 1.79949C6.00468 1.79949 6.82207 2.61689 6.82207 3.62162C6.82207 4.62635 6.00468 5.44373 4.99998 5.44373Z",
    fill: "#00B087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e63fddb8f75cf88afb377cd74e9bd7a3.svg";
export { ForwardRef as ReactComponent };